<div class="wm-code-editor" [ngClass]="customClasses" #wmsEditor>
  <div class="editor-loading-container" [ngClass]="editorLoadingTheme" *ngIf="loadingEditor">{{locale['MSG_LOADING_EDITOR']}}</div>
</div>
